import React, { useState, useEffect } from "react";
import styled from "styled-components";

import {
  IconCopyright,
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandYoutube,
  IconMapPin,
  IconPhone,
} from "@tabler/icons-react";
import logo from "../../assets/images/Icon.png";
import footerimage from "../../assets/images/footerimage.png";

// Footer Wrapper
// const FooterWrapper = styled.footer`
//   background-color: #f5f7fa;
//   padding: 2rem 3rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   border-top: 1px solid #e0e0e0;
//   font-family: Arial, sans-serif;

//   @media (max-width: 768px) {
//     flex-direction: column;
//     text-align: center;
//   }
// `;

const FooterWrapper = styled.footer`
  background-color: #f5f7fa;
  padding: 2rem 3rem;
  font-family: Arial, sans-serif;
  border-bottom: 10px solid black;
`;

// Left Section with contact details
const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    align-items: center;
  }

  img {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
  }
`;

const LogoImage = styled.img`
  width: 50px;
  height: auto;
  object-fit: contain;
  margin-bottom: 10px;
`;

const ContactDetails = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 1rem;
`;

const ContactItem = styled.div`
  margin-bottom: 0.5rem;
`;

// Right Section with buttons
const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 768px) {
    align-items: center;
    margin-top: 2rem;
  }

  button {
    margin-right: 1rem;
  }
`;

// Button styled component
const Button = styled.button`
  background-color: ${({ primary }) => (primary ? "#6ABD4B" : "transparent")};
  color: ${({ primary }) => (primary ? "#fff" : "#000")};
  border: ${({ primary }) => (primary ? "none" : "1px solid #000")};
  padding: 0.8rem 1.2rem;
  border-radius: 24px;
  cursor: pointer;
  font-size: 16px;
  margin: 0 0.5rem;

  &:hover {
    background-color: ${({ primary }) => (primary ? "#5AA33F" : "#f0f0f0")};
  }
`;

// Platform Icons Section
const PlatformSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
`;

const PlatformItem = styled.div`
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 0.5rem;
  }

  span {
    font-size: 14px;
    margin-left: 0.5rem;
  }
`;

// Horizontal Divider
const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 2rem 0;
`;

const TradeLiesence = styled.div`
  display: flex;
`;

const Termsandservices = styled.div`
  display: flex;
`;

// Footer Wrapper

// Newsletter Section
const NewsletterSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }

  h3 {
    font-size: 20px;
    margin-bottom: 1rem;
  }

  input {
    padding: 0.8rem;
    border: 1px solid #ccc;
    border-radius: 24px;
    margin-right: 10px;
    flex: 1;

    &:focus {
      outline: none;
    }
  }

  button {
    background-color: #6abd4b;
    color: white;
    border: none;
    padding: 0.8rem 1.2rem;
    border-radius: 24px;
    cursor: pointer;

    &:hover {
      background-color: #5aa33f;
    }
  }
`;

// Links Section (Platform, Company, Resources)
const LinksSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 1rem;
    font-size: 16px;
  }

  a {
    text-decoration: none;
    color: #333;
    margin-bottom: 0.5rem;
    font-size: 14px;

    &:hover {
      color: #6abd4b;
    }
  }
`;

// Bottom Section (Copyright and Terms)
const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }

  span {
    font-size: 14px;
  }
`;

// Add this styled component for the social icons
const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 2rem;
  }
`;

const SocialIcon = styled.a`
  color: #333;
  transition: color 0.3s ease;

  &:hover {
    color: #e2c7a6;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

// Replace the location card styled components with these new ones
const LocationCard = styled.div`
  background-color: transparent;
  width: 240px;

  h4 {
    font-size: 16px;
    margin-bottom: 1rem;
    color: #333;
    font-weight: 600;
    position: relative;
    display: inline-block;

    &:after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 30px;
      height: 2px;
      background-color: #e2c7a6;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 1.5rem auto;
  }
`;

const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const AddressBlock = styled.div`
  margin-bottom: 0.5rem;
  font-size: 13px;

  .location-name {
    font-weight: 600;
    color: #333;
    margin-bottom: 0.3rem;
  }

  .address {
    color: #666;
    line-height: 1.4;
    font-size: 12px;
    margin-bottom: 0.3rem;
  }

  .phone {
    a {
      color: #e2c7a6;
      text-decoration: none;
      font-size: 12px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const Footer = () => {
  // Remove the auto-scroll state and effect
  // const [activeAddress, setActiveAddress] = useState(0);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setActiveAddress((prev) => (prev === 0 ? 1 : 0));
  //   }, 5000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <FooterWrapper>
      {/* Newsletter Section */}
      {/* <NewsletterSection>
        <h3>Join our newsletter to keep up to date with us!</h3>
        <div>
          <input type="email" placeholder="Enter your email" />
          <button>Subscribe</button>
        </div>
      </NewsletterSection> */}

      {/* Links Section */}
      <LinksSection>
        <LeftSection>
          <LogoImage src={logo} alt="Logo" />
          <h2>Embark Properties</h2>
          <p>Navigating Markets, Driving growth</p>
          <SocialLinks>
            <SocialIcon
              href="https://facebook.com/embarkproperties"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandFacebook />
            </SocialIcon>
            <SocialIcon
              href="https://instagram.com/embarkproperties"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandInstagram />
            </SocialIcon>
            <SocialIcon
              href="https://linkedin.com/company/embarkproperties"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandLinkedin />
            </SocialIcon>
            <SocialIcon
              href="https://youtube.com/embarkproperties"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandYoutube />
            </SocialIcon>
          </SocialLinks>
        </LeftSection>

        <LinkGroup>
          <h4>Company</h4>
          <a href="/#intro">About</a>
          <a href="/#">News</a>
          <a href="/#">Blog</a>
        </LinkGroup>

        <LinkGroup>
          <h4>Resources</h4>
          <a href="/#contactus">Contact us</a>
          <a href="/career">Careers</a>
          <a href="/#people">People</a>
        </LinkGroup>

        {/* New Location Card Design */}
        <LocationCard>
          <h4>Our Locations</h4>
          <AddressWrapper>
            <AddressBlock>
              <div className="location-name">Dubai</div>
              <div className="address">
                Ali Khalifa Belaisha Building - Office M-02 - 131 Sheikh Rashid
                Rd - Al Karama - Dubai
              </div>
            </AddressBlock>
            <AddressBlock>
              <div className="location-name">India</div>
              <div className="address">
                H.no. 599/47 ward no 8 killa mohalla Tohana 125120 haryana India
              </div>
              <div className="phone">
                <a href="tel:+919992887878">+919992887878</a>
              </div>
            </AddressBlock>
          </AddressWrapper>
        </LocationCard>
      </LinksSection>

      {/* Bottom Section */}
      <BottomSection>
        <span>©️ 2024 Embark Properties. All rights reserved.</span>

        <Termsandservices>
          <PlatformItem>
            <span>
              <a href="/privacypolicy">Terms of Service</a>
            </span>
          </PlatformItem>
          <PlatformItem>
            <span>
              <a href="/privacypolicy">Privacy Policy</a>
            </span>
          </PlatformItem>
          <PlatformItem>
            <span>
              <a href="/privacypolicy">Cookies</a>
            </span>
          </PlatformItem>
        </Termsandservices>
      </BottomSection>
    </FooterWrapper>
  );
};

export default Footer;
